var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDots = function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 92,
    viewBox: "0 0 168 92"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.706,
    cy: 88.3812,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 163.706 88.3812)",
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.118,
    cy: 88.3812,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 128.118 88.3812)",
    fill: "currentColor"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.53,
    cy: 88.3812,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 92.53 88.3812)",
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.9412,
    cy: 88.3812,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 56.9412 88.3812)",
    fill: "currentColor"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.3533,
    cy: 88.3812,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 21.3533 88.3812)",
    fill: "currentColor"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.912,
    cy: 67.1698,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 145.912 67.1698)",
    fill: "currentColor"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.324,
    cy: 67.1698,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 110.324 67.1698)",
    fill: "currentColor"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.7351,
    cy: 67.1698,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 74.7351 67.1698)",
    fill: "currentColor"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.1472,
    cy: 67.1698,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 39.1472 67.1698)",
    fill: "currentColor"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.55836,
    cy: 67.1698,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 3.55836 67.1698)",
    fill: "currentColor"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.706,
    cy: 45.958,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 163.706 45.958)",
    fill: "currentColor"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.118,
    cy: 45.958,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 128.118 45.958)",
    fill: "currentColor"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.53,
    cy: 45.958,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 92.53 45.958)",
    fill: "currentColor"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.9412,
    cy: 45.958,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 56.9412 45.958)",
    fill: "currentColor"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.3533,
    cy: 45.9579,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 21.3533 45.9579)",
    fill: "currentColor"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.912,
    cy: 24.7466,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 145.912 24.7466)",
    fill: "currentColor"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.324,
    cy: 24.7466,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 110.324 24.7466)",
    fill: "currentColor"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.7351,
    cy: 24.7466,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 74.7351 24.7466)",
    fill: "currentColor"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.1472,
    cy: 24.7466,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 39.1472 24.7466)",
    fill: "currentColor"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.55836,
    cy: 24.7466,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 3.55836 24.7466)",
    fill: "currentColor"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.706,
    cy: 3.53518,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 163.706 3.53518)",
    fill: "currentColor"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.118,
    cy: 3.53518,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 128.118 3.53518)",
    fill: "currentColor"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.53,
    cy: 3.53518,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 92.53 3.53518)",
    fill: "currentColor"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.9412,
    cy: 3.53518,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 56.9412 3.53518)",
    fill: "currentColor"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.3533,
    cy: 3.53518,
    rx: 3.55882,
    ry: 3.53525,
    transform: "rotate(-180 21.3533 3.53518)",
    fill: "currentColor"
  })));
};

export default "data:image/svg+xml;base64,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";
export { SvgDots as ReactComponent };